import { CapabilityProps } from "./types/power-up"

const PUP_DISPLAY_NAME = "Import to Trello"
const PUP_ID = "7"

const CAPABILITY_PROPS: CapabilityProps = {
  baseUrl: typeof window !== "undefined" ? window.location.href.replace(/\/$/, "") : "",
  logo: {
    dark: "/static/bd-icon-dark.png",
    light: "/static/logo.png"
  },
  icon: {
    dark: "/static/bd-icon-dark.png",
    light: "/static/logo.png"
  },
  authorizeIcon: {
    dark: "/static/authorize-icon.svg",
    light: "/static/authorize-icon.svg"
  },
  upgradeIcon: {
    dark: "/static/upgrade-icon.svg",
    light: "/static/upgrade-icon.svg"
  }
}

/** Where this power-up serves the feedback header action's icon from. */
const FEEDBACK_ICON_PATH = "/static/feedback-icon.svg"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getImportModal = (): any => ({
  title: PUP_DISPLAY_NAME,
  url: "./list-action.html",
  fullscreen: true
})

const INITIAL_ROW_COUNT = 30

export {
  PUP_DISPLAY_NAME,
  PUP_ID,
  CAPABILITY_PROPS,
  INITIAL_ROW_COUNT,
  FEEDBACK_ICON_PATH,
  getImportModal
}
